module.exports = __webpack_public_path__ + "img/app-yaogan.be518bfc.jpg";